import React from 'react';
import X from '@uber/base-icons/x';
import { useStyletron } from 'baseui';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { LabelLarge, LabelSmall } from 'baseui/typography';
import type { StyleObject } from 'styletron-react';
import SideDrawer from '../../../common/utils/side-drawer';
const ButtonOverrides = {
  BaseButton: {
    style: ({
      $theme
    }) => ({
      padding: $theme.sizing.scale0,
      height: 'auto',
      width: 'auto'
    })
  }
};
export const ModernizationSideDrawer = ({
  children,
  title,
  description,
  onClose,
  isOpen,
  showDivider,
  styles
}: {
  children: React.ReactNode | ((props: {
    onClose: () => void;
  }) => React.ReactNode);
  title: () => React.ReactNode;
  description?: string;
  onClose?: () => void;
  isOpen: boolean;
  showDivider?: boolean;
  styles?: {
    containerStyles?: StyleObject;
    contentContainerStyles?: StyleObject;
    sideDrawerStyles?: StyleObject;
  };
}) => {
  const [css, theme] = useStyletron();
  const childContent = typeof children === 'function' ? children({
    onClose: () => {}
  }) : children;
  return <SideDrawer isOpen={isOpen} id="modernization-side-drawer" styles={styles?.sideDrawerStyles ?? {}}>
      <div className={css({
      height: '100%',
      padding: theme.sizing.scale500,
      display: 'flex',
      flexDirection: 'column',
      ...styles?.containerStyles
    })}>
        <section className={css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: theme.sizing.scale200
      })}>
          <div className={css({
          display: 'flex',
          alignItems: 'center',
          gap: theme.sizing.scale500
        })}>
            <LabelLarge margin={0} className={css({
            wordBreak: 'break-all'
          })}>
              {title()}
            </LabelLarge>
          </div>
          {onClose && <Button kind={KIND.tertiary} size={SIZE.compact} overrides={ButtonOverrides} shape={SHAPE.circle} onClick={onClose} aria-label="Close">
              <X size={theme.sizing.scale650} />
            </Button>}
        </section>
        {description && <section className={css({
        paddingTop: theme.sizing.scale400
      })}>
            <LabelSmall margin={0} color={theme.colors.contentTertiary}>
              {description}
            </LabelSmall>
          </section>}
        {showDivider && <hr className={css({
        width: `calc(100% + ${theme.sizing.scale500} * 2)`,
        height: '1px',
        border: 'none',
        backgroundColor: theme.colors.borderOpaque,
        margin: `${theme.sizing.scale600} -${theme.sizing.scale500} 0 -${theme.sizing.scale500}`
      })} />}
        <section className={css({
        paddingTop: theme.sizing.scale800,
        height: '100%',
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        ...(styles?.contentContainerStyles ?? {})
      })}>
          {childContent}
        </section>
      </div>
    </SideDrawer>;
};